import React, { ReactElement } from 'react';
import Form from 'react-bootstrap/Form';
import type { FormCheckProps } from 'react-bootstrap/FormCheck';
import styled from 'styled-components';

import { RequiredWrapper } from '../wrappers';
import { FormItemWrapper } from './wrappers';

const LabelWrapper = styled.label`
  color: ${({ theme }) => theme.colors.textOnBg};
  font-weight: 600;
  width: 100%;
  margin: 0 0 8px 16px;
`;

export const StyledFormCheck = styled(Form.Check)`
  input[type='checkbox'] {
    height: 1.25em;
    width: 1.25em;
    margin-right: 12px;
    margin-top: 0.125em;
  }
`;

export interface IFormCheckProps extends FormCheckProps {
  /** The label for the form item */
  label: string | ReactElement;
  /** Whether a required field */
  isRequired?: boolean;
}

export const StyledCheckbox: React.FC<IFormCheckProps> = ({
  label,
  isRequired,
  ...props
}) => (
  <FormItemWrapper>
    <StyledFormCheck
      type="checkbox"
      label={
        <LabelWrapper>
          {label}
          {isRequired && <RequiredWrapper>*</RequiredWrapper>}
        </LabelWrapper>
      }
      {...props}
    />
  </FormItemWrapper>
);
